import styled from 'styled-components'

const StyledIssueListView = styled.div`
  box-sizing: border-box;
  width: 100%;

  .issues-list {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-gap: 2rem 1rem;
    align-items: start;
    overflow: hidden;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xs}px) {
    .issues-list {
      grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));
      grid-gap: 24px 20px;
    }
  }
`

export default StyledIssueListView
